import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "selector"
  ]

  static values = {
    mapping: Object
  }

  initialize() {
    super.initialize()
    if (this.hasMappingValue) {
      this.select()
    }
  }

  select(event) {
    // this "|| 'community_admin'" hack had to be added as without it, the user (with community role)
    // would be getting different select helper for property and community admin form which we don't want to
    if (this.mappingValue.hasOwnProperty(this.selectorTarget.value || "community_admin")) {
      const data = this.mappingValue[this.selectorTarget.value || "community_admin"]
      if (data.hasOwnProperty("show")) {
        this.element.querySelectorAll(data["show"]).forEach(element => {
          element.classList.remove("hidden")
        })
      }
      if (data.hasOwnProperty("hide")) {
        this.element.querySelectorAll(data["hide"]).forEach(element => {
          element.classList.add("hidden")
        })
      }
    }
  }

  // This is used to pass the role name to the create tenant url
  createTenant(event) {
    const link = event.currentTarget
    const url = new URL(link.href)
    url.searchParams.set("role_name", this.selectorTarget.value)
    link.href = url.toString()
  }
}
